import { Box } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import { useCompanyConfig } from '../../hooks/CompanyConfiguration/useCompanyConfig'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

export default function GeneratePasswordDialog({ open, handleClose, form, passwordRequirement }) {
  const [state, setstate] = useState({
    minCharacter: 0,
    maxCharacter: 0,
    minNumber: 0,
    minSpecial: 0,
    minUppercase: 0,
    minLowercase: 0,
    // minSpecial:0,
  })
  const { updateCompanyAccount, getLoggedInUser, loggedUser } = useCompanyConfig()

  useEffect(() => {
    if (passwordRequirement) {
      setstate({ ...passwordRequirement })
    }
  }, [passwordRequirement])
  useEffect(() => {
    getLoggedInUser()
  }, [])

  const inputfields = [
    {
      label: 'Minimum Characters',
      value: state.minCharacter,
      name: 'minCharacter',
      type: 'NUMBER',
      grid: 6,
      noValidate: true,
    },
    {
      label: 'Maximum Characters',
      value: state.maxCharacter,
      name: 'maxCharacter',
      type: 'NUMBER',
      grid: 6,
      noValidate: true,
    },
    { label: 'Minimum Numbers', value: state.minNumber, name: 'minNumber', type: 'NUMBER', grid: 6, noValidate: true },
    {
      label: 'Minimum Special Characters',
      value: state.minSpecial,
      name: 'minSpecial',
      type: 'NUMBER',
      grid: 6,
      noValidate: true,
    },
    {
      label: 'Minimum UpperCase Characters',
      value: state.minUppercase,
      name: 'minUppercase',
      type: 'NUMBER',
      grid: 6,
      noValidate: true,
    },
    {
      label: 'Minimum LowerCase Characters',
      value: state.minLowercase,
      name: 'minLowercase',
      type: 'NUMBER',
      grid: 6,
      noValidate: true,
    },
  ]
  const handleGeneratePasswordPolicy = () => {
    // setForm({ ...form, passwordRequirement: state })
    updateCompanyAccount({ ...loggedUser, passwordRequirement: state })
    handleClose()
  }

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <HeadingWithCloseIcon heading={`${passwordRequirement ? 'Edit' : 'Generate'} Password Requirement`} handleClose={handleClose} />
      <CustomAddForm state={state} setState={setstate} data={inputfields} />
      <Box display="flex" justifyContent="center" marginTop="30px">
        <Box>
          <CustomButton text="Cancel" handleSubmit={handleClose} />
        </Box>
        <Box>
          <CustomButton text="Submit" handleSubmit={handleGeneratePasswordPolicy} />
        </Box>
      </Box>
    </CustomDialog>
  )
}
